<template>
    <div>
        <loading-container v-if="loading"></loading-container>

        <div v-else>
            <headline-container :headline="user.attributes.full_name" :breadcrumbs="breadcrumbs">
                <div class="btn-group">
                    <button type="button" class="btn btn-white dropdown-toggle" data-toggle="dropdown">
                        <i class="fa fa-cogs"></i> User Functions <span class="caret"></span>
                    </button>

                    <ul class="dropdown-menu">
                        <li>
                            <a @click.prevent="destroy">
                                <i class="fa fa-trash"></i> Delete
                            </a>
                        </li>
                    </ul>
                </div>
            </headline-container>

            <sub-menu :user="user"></sub-menu>

            <router-view v-model="user"></router-view>
        </div>
    </div>
</template>

<script>
import http from '../../../../http'
import modal from '../../../../modal'
import notify from '../../../../notify'
import HeadlineContainer from '../../../../components/Layout/HeadlineContainer'
import LoadingContainer from '../../../../components/Layout/LoadingContainer'
import SubMenu from './SubMenu'

export default {
    components: {HeadlineContainer, LoadingContainer, SubMenu},

    props: {
        userId: {
            required: true
        }
    },

    data() {
        return {
            user: null,

            loading: true
        }
    },

    mounted() {
        http.get('/api/v2/users/' + this.userId).then(response => {
            this.user = response.data.data

            this.loading = false
        })
    },

    computed: {
        breadcrumbs() {
            return [{url: '/users', text: 'Users'}, {text: this.user.attributes.full_name}]
        }
    },

    methods: {
        destroy() {
            modal.confirm('Are you sure that you want to delete the user?', () => {
                http.delete('/api/v2/users/' + this.userId)
                    .then(() => {
                        notify.success('The user was deleted')

                        this.$router.push('/users')
                    })
            })
        }
    }
}
</script>
